export const VueBrowseClasses =
{
    Container: "vueBrowse",
    OverflowUnset: "vueBrowse--overflowUnset",
    ContainerSelected: "vueBrowse--selected",
    Table: "vueBrowse__table",
    THead: "vueBrowse__thead",
    TBody: "vueBrowse__tbody",
    TFoot: "vueBrowse__tfoot",
    HeaderRow: "vueBrowse__headerRow",
    HeaderCell: "vueBrowse__headerCell",
    HeaderCellContent: "vueBrowse__headerCellContent",
    BodyRow: "vueBrowse__bodyRow",
    BodyRowSelected: "vueBrowse__bodyRow--selected",
    BodyCell: "vueBrowse__bodyCell",
    BodyCellContent: "vueBrowse__bodyCellContent",
    BodyCellContentHasButton: "vueBrowse__bodyCellContent--buttonCell",
    BodyCellContentEmpty: "vueBrowse__bodyCellContent--noRecords",
    Body: "vueBrowse__body",
    InnerBody: "vueBrowse__innerBody",
    UnlockedBody: "vueBrowse__unlockedBody",
    StaticHeight: "vueBrowse--staticHeight",
    DynamicHeight: "vueBrowse--dynamicHeight",
    BrowseWidgetNoRecords: "browseWidget--noRecords",
};
Object.freeze(VueBrowseClasses);